import * as contentful from 'contentful';
export const createClient = contentful.createClient;